// extracted by mini-css-extract-plugin
export var attachmentContainer = "_m9-0";
export var fileList = "_m9-2";
export var removeFileButton = "_m9-1";